import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { color } from '../../theme/tokens';

// Consistent page title block: eyebrow → title → description → actions.
const PageHeader = ({ title, subtitle, eyebrow, actions, children, sx }) => (
  <Box
    sx={{
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      gap: 2,
      mb: 3,
      ...sx,
    }}
  >
    <Box sx={{ minWidth: 0, flex: '1 1 320px' }}>
      {eyebrow && (
        <Typography
          variant="overline"
          sx={{ display: 'block', color: color.primary[600], mb: 0.5, fontWeight: 700 }}
        >
          {eyebrow}
        </Typography>
      )}
      <Typography
        component="h1"
        sx={{
          fontSize: { xs: '1.25rem', md: '1.5rem' },
          fontWeight: 600,
          color: color.ink[900],
          letterSpacing: '-0.015em',
          lineHeight: 1.25,
        }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography sx={{ mt: 0.5, fontSize: '0.875rem', color: color.ink[500], maxWidth: 720 }}>
          {subtitle}
        </Typography>
      )}
      {children}
    </Box>

    {actions && (
      <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap>
        {actions}
      </Stack>
    )}
  </Box>
);

export default PageHeader;
